import { motion } from "framer-motion";
import { Lock, Unlock, Plus, Gift } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CountUp } from "@/components/CountUp";
import { eur } from "@/lib/format";

export function PromotionCard({ promo, index = 0, onRegister }) {
  const unlocked = promo.achieved;
  const pct = promo.target ? Math.min(100, Math.round((promo.count / promo.target) * 100)) : 100;
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
      data-testid={`promotion-card-${promo.id}`}
    >
      <Card className="h-full p-6 bg-[#FFFFFF] border-[#DCE7F5] hover:border-[#0B6BCB]/40 transition-colors duration-200 flex flex-col">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="font-display font-semibold text-lg tracking-tight">{promo.name}</h3>
            <p className="text-xs text-[#5A6B85] mt-0.5 flex items-center gap-1">
              <Gift className="w-3 h-3 text-[#0B6BCB]" strokeWidth={1.5} /> {promo.prize} · {eur(promo.value_per_sale)}/{promo.type === "pezzi" ? "pezzo" : "vendita"}
            </p>
          </div>
          <Badge
            className={
              unlocked
                ? "bg-[#0B6BCB]/15 text-[#0B6BCB] border-[#0B6BCB]/30"
                : "bg-[#EEF4FC] text-[#5A6B85] border-[#DCE7F5]"
            }
            data-testid={`promotion-status-${promo.id}`}
          >
            {unlocked ? <Unlock className="w-3 h-3 mr-1" strokeWidth={2} /> : <Lock className="w-3 h-3 mr-1" strokeWidth={2} />}
            {unlocked ? "Sbloccato" : "Bloccato"}
          </Badge>
        </div>

        <div className="mb-2 flex items-end justify-between">
          <span className="text-xs text-[#5A6B85]">{promo.type === "pezzi" ? "Pezzi" : "Vendite"} / Soglia</span>
          <span className="text-sm font-medium">
            <span className="text-[#0F1E33]">{promo.count}</span>
            <span className="text-[#5A6B85]"> / {promo.target}</span>
          </span>
        </div>
        <Progress value={pct} className="h-2 bg-[#DCE7F5] [&>div]:bg-[#0B6BCB]" data-testid={`promotion-progress-${promo.id}`} />

        <div className="mt-5 pt-4 border-t border-[#DCE7F5]">
          <span className="text-xs text-[#5A6B85] uppercase tracking-wide">Premio maturato</span>
          <div className="font-display font-bold text-3xl tracking-tight mt-1" data-testid={`promotion-prize-${promo.id}`}>
            {unlocked ? (
              <CountUp value={promo.prize_value} prefix="€ " decimals={2} className="text-[#0B6BCB]" />
            ) : (
              <span className="text-[#94A3B8]">€ 0,00</span>
            )}
          </div>
          {!unlocked && (
            <p className="text-xs text-[#5A6B85] mt-1" data-testid={`promotion-hint-${promo.id}`}>
              Mancano {Math.max(0, promo.target - promo.count)} {promo.type === "pezzi" ? "pezzi" : "vendite"} per sbloccare il premio
            </p>
          )}
        </div>

        {onRegister && (
          <Button
            onClick={() => onRegister(promo)}
            className="mt-4 w-full bg-[#EEF4FC] hover:bg-[#0B6BCB] hover:text-[#FFFFFF] border border-[#DCE7F5] text-[#0F1E33] transition-colors"
            data-testid={`register-sale-btn-${promo.id}`}
          >
            <Plus className="w-4 h-4 mr-1.5" strokeWidth={2} /> Registra vendita
          </Button>
        )}
      </Card>
    </motion.div>
  );
}
